import script from "./Atendimento.vue?vue&type=script&setup=true&lang=ts"
export * from "./Atendimento.vue?vue&type=script&setup=true&lang=ts"

import "./Atendimento.vue?vue&type=style&index=0&id=9244a750&scoped=true&lang=css"

import exportComponent from "D:\\FOP\\AGAPE\\AGAPE_HOSPITALAR\\ReguaHospitalar\\ProntuarioWeb\\FrontEnd\\front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9244a750"]])

export default __exports__